module.exports = import("mfe-playbook");;